import { useState } from "react";
import "./Video.css";

function Video() {
  const [playVideo, setPlayVideo] = useState(false);

  const videoId = "9PqcZcM3GlU";
  const startTime = 7096; // Seconds

  return (
    <div className="video-wrapper">
      {!playVideo ? (
        <div className="thumbnail-container" onClick={() => setPlayVideo(true)}>
          <img
            src={`https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`}
            alt="Video thumbnail"
          />

          <button className="play-button">▶</button>
        </div>
      ) : (
        <iframe
          src={`https://www.youtube.com/embed/${videoId}?start=${startTime}&autoplay=1`}
          title="YouTube video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      )}
    </div>
  );
}

export default Video;
